/** Página não encontrada — fora do trilho, para funcionar mesmo sem sessão. */
import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';

export function NotFound() {
  return (
    <div className="content">
      <div className="empty stack-lg">
        <p className="display display-hero">404</p>
        <div>
          <p className="empty-title display">Essa página não existe</p>
          <p className="muted">O endereço pode ter mudado, ou nunca existiu. Volte para o painel.</p>
        </div>
        <Link to="/">
          <Button>Ir para o painel</Button>
        </Link>
      </div>
    </div>
  );
}
